module.exports = __webpack_public_path__ + "static/media/visa.118f0f4f.svg";